import React from 'react';
import CompanySubscriptionTabView from './CompanySubscriptionTabView';
import { useCompanySubscriptionTabController } from '../../../controllers';
import { CompanySubscriptionTabProps } from '../../../types';

const CompanySubscriptionTab = (props: CompanySubscriptionTabProps) => {
  const viewModel = useCompanySubscriptionTabController(props);
  return <CompanySubscriptionTabView {...viewModel} />;
};

export default CompanySubscriptionTab;
